import React, { FC } from 'react';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi';
import { StepId } from 'config/steps';
import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import styles from '../LandingPageStep.scss';
import { HeaderLogo } from 'components/Header/HeaderLogo';

export const LandingPageStepContent: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const handlePrimaryButtonClick = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SelectCategory],
      action: BI_ACTION_NAME.CONTINUE,
    });
    next();
  };

  return (
    <div className={styles.landingPageStepContent}>
      <HeaderLogo />
      <div className={styles.landingPageStepContentTypography}>
        <p className={styles.landingPageStepContentTitle}>
          <Trans i18nKey="landing-page-step.title" components={{ br: <br /> }} />
        </p>
        <p className={styles.landingPageStepContentDescription}>
          <Trans i18nKey="landing-page-step.description" components={{ br: <br /> }} />
        </p>
      </div>
      <button className={styles.landingPageStepContentButton} onClick={handlePrimaryButtonClick}>
        {t('landing-page-step.primary-button')}
      </button>
    </div>
  );
};
